import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Container from "@mui/material/Container";
import Typography from "../../components/Typography";

const ImageBackdrop = styled("div")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: "#000",
  opacity: 0.5,
  transition: theme.transitions.create("opacity"),
}));

const ImageIconButton = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  display: "block",
  padding: 0,
  borderRadius: 0,
  height: "40vh",
  [theme.breakpoints.down("md")]: {
    width: "100% !important",
    height: 100,
  },
  "&:hover": {
    zIndex: 1,
  },
  "&:hover .imageBackdrop": {
    opacity: 0.15,
  },
  "&:hover .imageMarked": {
    opacity: 0,
  },
  "&:hover .imageTitle": {
    border: "4px solid currentColor",
  },
  "& .imageTitle": {
    position: "relative",
    padding: `${theme.spacing(2)} ${theme.spacing(4)} 14px`,
  },
  "& .imageMarked": {
    height: 3,
    width: 18,
    background: theme.palette.common.white,
    position: "absolute",
    bottom: -2,
    left: "calc(50% - 9px)",
    transition: theme.transitions.create("opacity"),
  },
}));

const images = [
  {
    url: "https://blog.shiftcode.com.br/wp-content/uploads/2017/11/texto-11.png",
    title: "Sistemas",
    width: "40%",
  },
  {
    url: "https://esparta.io/wp-content/uploads/2019/04/por-que-optar-por-terceirizar-criacao-de-aplicativos.jpg",
    title: "Apps",
    width: "20%",
  },
  {
    url: "https://web41.com.br/wp-content/uploads/2022/02/sites-responsivos.png",
    title: "Sites",
    width: "40%",
  },
  {
    url: "https://www.cyfe.com/wp-content/uploads/2021/03/cyfe_new_hero_image-min-768x444-1.png",
    title: "Dashbords",
    width: "38%",
  },
  {
    url: "https://www.intervention.com.br/upload/service/5fULPzcqAurFMr78at0XUEJFgmiMyK1CXgdVTcfU.jpeg",
    title: "Sql",
    width: "38%",
  },
  {
    url: "https://logap.com.br/wp-content/uploads/2022/01/Banco-de-dados-NAO-relacional.png",
    title: "NoSql",
    width: "24%",
  },
  {
    url: "https://www.winspire.com.br/wp-content/uploads/2017/10/cloud-computing-813x406.jpg",
    title: "Cloud",
    width: "40%",
  },
  {
    url: "https://blog.geekhunter.com.br/wp-content/uploads/2019/06/docker-na-pratica-como-construir-uma-aplicacao-2.png",
    title: "Docker",
    width: "20%",
  },
  {
    url: "https://uds.com.br/blog/wp-content/uploads/2022/11/Boas-praticas-em-arquitetura-de-software.jpg",
    title: "Arquitetura",
    width: "40%",
  },
];

export default function ProductCategories() {
  return (
    <Container component="section" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" marked="center" align="center" component="h2">
        O que fazemos
      </Typography>
      <Box sx={{ mt: 8, display: "flex", flexWrap: "wrap" }}>
        {images.map((image) => (
          <ImageIconButton
            key={image.title}
            style={{
              width: image.width,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundSize: "cover",
                backgroundPosition: "center 40%",
                backgroundImage: `url(${image.url})`,
              }}
            />
            <ImageBackdrop className="imageBackdrop" />
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "common.white",
              }}
            >
              <Typography
                component="h3"
                variant="h6"
                color="inherit"
                className="imageTitle"
              >
                {image.title}
                <div className="imageMarked" />
              </Typography>
            </Box>
          </ImageIconButton>
        ))}
      </Box>
    </Container>
  );
}
